export default {"src":"/_next/static/media/Ro.05c8e275.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};